
export const ECDWizardInitialValues =
{
    surveyQuestions: [
        {
            id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            questionId: 0,
            question: 'string',
            answer: {
                id: 0,
                value: 'string'
            },
            sectionId: 0
        }
    ]
}

export const DRCSignOffInitialValues =
{
    surveyQuestions: [
        {
            id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            questionId: 0,
            question: '',
            answer: {
                id: 0,
                value: ''
            }
        }
    ]
}

export const PCCInitialValues =
{
    surveyQuestions: [
        {
            id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            questionId: 0,
            question: '',
            answer: {
                id: 0,
                value: ''
            }
        }
    ]
}